import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {MenuType, WindowSize, ZoneView} from "../models";
import {Observer} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ViewsService {
    hidden: boolean = false;
    submenuWindowWidth: number = 0;
    submenuWindowHeight: string = '';
    manufacturerMaxHeight: string = '';
    alarmHistoryContentHeight: string = '';
    alarmHistoryListHeight: string = '';
    zonesView: ZoneView = {
        show: false,
        downloaded: false,
        withoutGlobalSchedules: false
    }
    isRecaptchaReady = false;
    private captchaObserver: MutationObserver;

    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    hideView(): void {
        this.hidden = true;
    }

    showView(): void {
        this.hidden = false;
    }

    private countWidthAndHeight(): WindowSize {
        const windowWidth = window.innerWidth
        let windowHeight: number;

        if (windowWidth > 1365) {
            windowHeight = window.innerHeight - 95; // top menu + footer
        } else if (this.submenuWindowWidth > 960 && this.submenuWindowWidth <= 1365) {
            windowHeight = window.innerHeight - 143;
        } else {
            windowHeight = window.innerHeight - 108;
        }

        return {
            windowWidth,
            windowHeight,
        }
    }

    setSubMenuWindowValues(): void {
        const {windowWidth, windowHeight} = this.countWidthAndHeight();

        this.submenuWindowWidth = windowWidth
        this.submenuWindowHeight = `${windowHeight}px`;
    }

    setManufacturerMaxHeight(): void {
        const {windowHeight} = this.countWidthAndHeight();

        this.manufacturerMaxHeight = `${windowHeight - (windowHeight / 2)}px`;
    }

    setAlarmHistoryHeights(): void {
        const {windowHeight} = this.countWidthAndHeight();

        this.alarmHistoryContentHeight = `${windowHeight - windowHeight / 8}px`;
        this.alarmHistoryListHeight = `${windowHeight - windowHeight / 8 - 230}px`;
    }

    setIconUrl(val: string): string {
        switch (val) {
            case MenuType.MU:
                return "/assets/img/top_menu/menu.svg";
            case MenuType.MS:
                return "/assets/img/top_menu/menu_service.svg";
            case MenuType.MI:
                return "/assets/img/top_menu/menu_fitters.svg";
            case MenuType.MP:
                return "/assets/img/top_menu/menu_manufacturer.svg";
            default:
                return "/assets/img/id_icons/" + val + ".svg";
        }
    }

    isMobileView(): boolean {
        return this.document.body.clientWidth < 697;
    }

    isDesktopView(): boolean {
        return this.document.body.clientWidth >= 960;
    }

    checkCaptchaIsReady() {
        this.captchaObserver = new MutationObserver(() => {
            const iframe = document.querySelector('iframe[src*="recaptcha"]') as HTMLIFrameElement;
            if (iframe) {
                iframe.onload = () => {
                    this.isRecaptchaReady = true;
                };
            }
        });
        this.captchaObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    hideCaptchaLoader() {
        this.captchaObserver.disconnect();
        this.isRecaptchaReady = false;
    }
}
